import React from 'react';

import GenericNameTemplateField from 'name-templates/GenericNameTemplateField';
import {NameTemplatePart, NameTemplateType} from 'name-templates/NameTemplateConstants';
import SetNameTemplateModal, {SET_NAME_TEMPLATE_MODAL_KEY} from 'name-templates/SetNameTemplateModal';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';
import {SettingsPopover} from 'ui-library/SettingsField';

export interface StudyNameTemplateFieldProps {
  schemaFields: Array<SchemaField | ClientSchemaField>;
  schemaId: string;
  nameTemplateParts: Array<NameTemplatePart>;
  isWritable: boolean; // whether we allow changing the name template
  setNameTemplateParts: (parts: Array<NameTemplatePart>) => Promise<boolean>;
}

export default class StudyNameTemplateField extends React.Component<StudyNameTemplateFieldProps> {
  openSetNameTemplateModal = (): void => {
    LegacyModalContainer.open(
      SET_NAME_TEMPLATE_MODAL_KEY,
      <SetNameTemplateModal
        bioentityType=""
        schemaFields={this.props.schemaFields}
        sequenceType={null}
        schemaId={this.props.schemaId}
        initialNameTemplateParts={this.props.nameTemplateParts}
        nameTemplateType={NameTemplateType.STUDY}
        itemType={null}
        onRequestSubmit={async (submitArgs) => {
          const didSubmit = await this.props.setNameTemplateParts(submitArgs.nameTemplateParts);
          if (didSubmit) {
            this.closeSetNameTemplateModal();
          }
        }}
        onRequestClose={this.closeSetNameTemplateModal}
      />
    );
  };

  closeSetNameTemplateModal = (): void => {
    LegacyModalContainer.close(SET_NAME_TEMPLATE_MODAL_KEY);
  };

  handleRemoveNameTemplate = (): void => {
    this.props.setNameTemplateParts([]);
  };

  override render(): JSX.Element {
    const helpIconContent = (
      <SettingsPopover
        title="Study name template"
        renderContent={() => (
          <div className="tagSchemaSettings-popover">
            <p>
              You can automatically name studies based on a naming template. If the name template is changed,
              it will not affect the names of existing studies.
            </p>
          </div>
        )}
      />
    );

    return (
      <GenericNameTemplateField
        label="Study name template"
        sequenceType={null}
        bioentityType=""
        {...this.props}
        helpIconContent={helpIconContent}
        setNameTemplateParts={this.openSetNameTemplateModal}
        removeNameTemplateParts={this.handleRemoveNameTemplate}
      />
    );
  }
}
